


























































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { DataApi } from '../models/NDVBase.model';

@Component({ components: {} })
export default class TabNDV extends Vue {
  @Prop({ required: true, default: {} }) data!: DataApi;
}
